"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setInboxRuleRequest_1 = require("owa-service/lib/factory/setInboxRuleRequest");
var setInboxRuleOperation_1 = require("owa-service/lib/operation/setInboxRuleOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Set inbox rule service
 * @param inboxRule the rule to update
 * @return SetInboxRuleResponse
 */
function setInboxRuleService(inboxRule) {
    var requestBody = setInboxRuleRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        InboxRule: inboxRule,
    });
    return setInboxRuleOperation_1.default(requestBody);
}
exports.default = setInboxRuleService;
//# sourceMappingURL=setInboxRuleService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/services/setInboxRuleService.js
// module id = 5234
// module chunks = 2